import * as Inovx from '@shared';
import type { IHomeFacility } from '../constants/interfaces';

const UrlUtilities = Inovx.Shared.Common.UrlUtilities;

const HomeFacilityServices = Object.assign({}, Inovx.Shared.Flux.BaseService, {
    getAll(): Promise<IHomeFacility[]> {
        const url = UrlUtilities.getApiUrl() + '/FacilityApi/api/facility';
        return new Promise<IHomeFacility[]>((resolve, reject) => {
            this.get(
                url,
                null,
                (data: IHomeFacility[]) => resolve(data),
                (error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
});

export default HomeFacilityServices;
